import type { AgentToolPolicy } from '@this+that/models';

/** Rebuilds policies field by field so Apollo's `__typename` (and anything else
 *  a response adds) can never reach `AgentToolPolicyInput`. */
export function toToolPolicyInputs(
  policies: readonly AgentToolPolicy[] | null | undefined,
): AgentToolPolicy[] {
  return (policies ?? []).map((policy) => ({
    connectionId: policy.connectionId,
    allowedTools: [...policy.allowedTools],
    limits: (policy.limits ?? []).map(({ tool, param, max }) => ({
      tool,
      param,
      max,
    })),
  }));
}
